import React, { useState } from 'react';
import { ImagePlus, X } from 'lucide-react';
import MediaPicker from './MediaPicker';

/**
 * Campo de imagen unificado: sustituye a los campos "Imagen (URL)".
 * Sin URLs manuales — selección desde la Biblioteca Multimedia con vista previa.
 */
export default function ImageField({ label, value, onChange, ownerId = 'matriz', testid, type = 'image' }) {
  const [open, setOpen] = useState(false);
  const noun = type === 'video' ? 'vídeo' : 'imagen';

  return (
    <div>
      <label className="block text-xs font-bold text-stone-500 mb-1">{label}</label>
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative group shrink-0">
            {type === 'video' ? (
              <video src={value} className="w-16 h-12 object-cover rounded border border-stone-200 bg-black" preload="metadata" muted />
            ) : (
              <img src={value} alt="" className="w-16 h-12 object-cover rounded border border-stone-200 bg-stone-50" />
            )}
            <button
              type="button"
              onClick={() => onChange('')}
              className="absolute -top-2 -right-2 bg-red-500 hover:bg-red-600 transition-colors text-white rounded-full w-5 h-5 flex items-center justify-center"
              title={`Quitar ${noun}`}
              data-testid={testid ? `${testid}-clear` : undefined}
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        ) : (
          <div className="w-16 h-12 rounded border border-dashed border-stone-300 bg-stone-50 flex items-center justify-center shrink-0">
            <ImagePlus className="w-4 h-4 text-stone-300" />
          </div>
        )}
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="border border-stone-300 hover:border-stone-500 transition-colors text-stone-700 px-3 py-2 rounded text-xs font-bold"
          data-testid={testid}
        >
          {value ? `Cambiar ${noun}` : `Seleccionar ${noun}`}
        </button>
      </div>
      <MediaPicker open={open} onClose={() => setOpen(false)} onSelect={onChange} ownerId={ownerId} type={type} />
    </div>
  );
}
